<script setup>
const { $on, $emit, $notify } = useNuxtApp()
const type = ref('confirmDialog') // prompt
$on('confirmDialog', confirmDialog)
$on('signatureDialog', signatureDialog)
$on('promptDialog', promptDialog)

const msg = ref('')
const title = ref('')
const visible = ref(false)

const loading = ref(false)
const password = ref('')
const userInput = ref('')
const name = ref('')

function signatureDialog (ev) {
  password.value = ''
  type.value = 'signatureDialog'
  msg.value = `You are about to sign and approve the document <strong>${ev.documentName}</strong>.<br>
Signing this document constitutes your legal electronic signature under 21 CFR Part 11.`
  title.value = 'Signature required '
  visible.value = true
}

function confirmDialog (ev) {
  type.value = 'confirmDialog'
  msg.value = ev.msg
  title.value = ev.title || 'Confirm'
  visible.value = true
}

function promptDialog (ev) {
  type.value = 'promptDialog'
  msg.value = ev.msg
  title.value = ev.title
  name.value = ev.name
  visible.value = true
}

function result (value) {
  visible.value = false
  if (['confirmDialog', 'signatureDialog'].includes(type.value)) {
    $emit(`${type.value}:result`, value)
  } else {
    $emit('promptDialog:result', value && userInput.value )
    userInput.value = ''
  }
}

async function checkPassword () {
  loading.value = true
  try {
    await useAPI('auth/checkPassword', { method: 'POST', body: { password: password.value }})
    result(true)
    $notify('You succesfully signed this document', 'success')
  } catch (e) {
    console.error(e)
    $notify('Password validation failed!')
  }
  loading.value = false
}

</script>
<template>
  <v-dialog v-model='visible' width="400px">
    <CoreCard color="warning" icon='$warning' :title="title" @confirm="result(true)" @cancel="result(false)" show-cancel>
        <div v-html='msg' />

        <!-- Prompt Dialog -->
        <v-textarea v-if='type === "promptDialog"' :label='name' v-model='userInput' id="dialog-field-prompt"/>
        <template v-if='type === "promptDialog"' v-slot:actions>
            <v-btn color='warning' @click="result(false)" icon="mdi-close" class="confirm-btn-cancel" id="dialog-btn-cancel"></v-btn>
            <v-btn :disabled='!userInput.length' color='success' @click="result(userInput)" text label icon="mdi-check" class="confirm-btn-ok" id="dialog-btn-ok"></v-btn>
        </template>

        <!-- Signature Dialog -->
        <v-text-field type='password' v-if='type === "signatureDialog"' label='Password' v-model='password' class='mt-4' id="dialog-field-password"/>
        <template v-if="type === 'signatureDialog'" v-slot:actions>
          <v-btn color='warning' @click="result(false)" icon="mdi-close" class="confirm-btn-cancel" id="dialog-btn-cancel"></v-btn>
          <v-btn :loading='loading' :disabled='!password.length || loading' color='success' @click="checkPassword()" text label icon="mdi-pen" class="confirm-btn-ok" id="dialog-btn-ok"></v-btn>          
        </template>

    </CoreCard>
  </v-dialog>
</template>
